module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    ref: "dialog",
    attrs: {
      "max-width": "600px",
      "fullscreen": _vm.screenWidth < 600,
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    style: ({
      backgroundColor: this.styles.general.theme_color_light
    })
  }, [_c('v-layout', [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.closeViewEvent
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pb-4 mx-2 px-2"
  }, [_c('v-flex', {
    staticClass: "text-xs-center event_icon",
    attrs: {
      "xs2": ""
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.item.logo ? _vm.item.logo : '/static/images/event-icon.png'
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "mx-4 event_title",
    attrs: {
      "xs10": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.title))])])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-flex', {
    staticClass: "event_share",
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.item.link,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "medium": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("date_range")]), _vm._v("\n            RSVP\n          ")], 1)], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "event_share",
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [(!_vm.favorited) ? _c('v-btn', {
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "medium": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.favoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("favorite")]), _vm._v("\n            Favorite\n          ")], 1)], 1) : _c('v-btn', {
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "medium": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unfavoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": "",
      "color": "red"
    }
  }, [_vm._v("favorite")]), _vm._v("\n            Favorite\n          ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "event_share",
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('share-button', {
    attrs: {
      "color": "secondary",
      "text": "Share",
      "size": "28px",
      "link": _vm.link
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mx-3",
    style: (_vm.resize),
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Description")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.item.description || '-'))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', [_vm._v("query_builder")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("actualDate")(_vm.item.eventdate)) + " at " + _vm._s(_vm.item.starteventtime) + " ")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', [_vm._v("room")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.location || '-'))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', [_vm._v("date_range")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.user.firstname + ' ' + _vm.item.user.lastname) + " - " + _vm._s(_vm.item.user.jobtitle || '-'))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2 event_link",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', [_vm._v("link")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.item.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.link))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2831fc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/grouppage/events/EventViewModal.vue
// module id = 1114
// module chunks = 16 17 24